import { cva } from 'class-variance-authority';

import { useSearchResultCardContext } from './SearchResultCardProvider';
import { Headline } from '../Headline/Headline';

import styles from './SearchResultCardContent.module.css';

const headlineVariants = cva(styles.headline, {
  variants: {
    variant: {
      default: styles.defaultHeadline,
      preview: styles.previewHeadline,
    },
  },
});

export const SearchResultCardHeadline = () => {
  const { headlineAs, link, variant } = useSearchResultCardContext();

  return (
    <Headline
      className={headlineVariants({ variant })}
      size="h6"
      as={headlineAs}
      label={link.label}
      data-testid="search-components_result-card_headline"
    />
  );
};
